import { useEffect, useState } from "react";
import useInterval from "use-interval";
import { Checkbox, Button, VStack, Text, Divider } from "@chakra-ui/react";
import { RepeatIcon } from "@chakra-ui/icons";

import BaseLayout from "../templates/BaseLayout";
import ContractLayout from "../templates/ContractLayout";
import Manual from "./Manual";
import FeedItem from "./FeedItem";
import ClaimItem from "./ClaimItem";
import { trimAddress } from "../utils/address";
import { getRefreshTime } from "../utils/consts";
import safeGetParams from "../utils/safeGetParams";

export default function HomeBase({ contractInfo }) {
    const refreshTime = getRefreshTime(contractInfo.network);

    const [contract, setContract] = useState(null);
    const [address, setAddress] = useState(null);
    const [pageIsLoading, setPageIsLoading] = useState(false);
    const [tokens, setTokens] = useState([]);
    const [aliveOnly, setAliveOnly] = useState(false);

    function updateTokensArray(tokenId, params) {
        setTokens((prev) => {
            const newItem = { tokenId, ...params };
            const index = prev.findIndex((p) => p.tokenId === tokenId); //p.tokenId.toString() === tokenId.toString());
            if (index === -1) {
                return [...prev, newItem];
            } else {
                let newArray = [...prev];
                newArray[index] = newItem;
                return newArray;
            }
        });
    }

    async function loadTokenByTokenId(tokenId) {
        try {
            const params = await safeGetParams(contract, tokenId);
            if (params.error) {
                console.warn("loadTokenByTokenId", tokenId, params.error);
            } else {
                updateTokensArray(tokenId, params);
            }
        } catch (error) {
            console.error("loadTokenByTokenId", tokenId, error.message);
        }
    }

    async function loadTokenByIndex(i) {
        try {
            const tokenIdBN = await contract.tokenOfOwnerByIndex(address, i);
            const tokenId = tokenIdBN.toNumber();
            await loadTokenByTokenId(tokenId);
        } catch (error) {
            console.error("loadTokenByIndex", i, error.message);
        }
    }

    async function loadAllTokens(reset) {
        if (reset) setTokens([]);
        if (!contract || !address) return;
        const balance = await contract.balanceOf(address);
        const tasks = [];
        for (let i = 0; i < balance; i++) {
            const task = loadTokenByIndex(i);
            tasks.push(task);
        }
        await Promise.all(tasks);
    }

    useEffect(() => {
        loadAllTokens(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contract, address]);

    useInterval(
        () => {
            console.log("timer", new Date().toLocaleString());
            loadAllTokens(false);
        },
        pageIsLoading ? null : refreshTime
    );

    async function reload() {
        setPageIsLoading(true);
        await loadAllTokens(true);
        setPageIsLoading(false);
    }

    function sortFunc(a, b) {
        return b.tokenId - a.tokenId;
    }
    function matchFilter(t) {
        return !aliveOnly || t.isAlive;
    }

    return (
        <BaseLayout isHome={true} network={contractInfo.network}>
            <VStack>
                <Manual network={contractInfo.network} />
            </VStack>

            <ContractLayout
                contractInfo={contractInfo}
                contract={contract}
                setContract={setContract}
                address={address}
                setAddress={setAddress}
            >
                <VStack spacing="5">
                    <Text color="blue.600" fontWeight="semibold">
                        Wallet Address: {trimAddress(address)}
                    </Text>
                    <Divider />

                    {tokens
                        .filter((t) => matchFilter(t))
                        .sort(sortFunc)
                        .map((t) => (
                            <FeedItem
                                key={t.tokenId}
                                contract={contract}
                                token={t}
                                onFeeded={() => loadTokenByTokenId(t.tokenId)}
                                setPageIsLoading={setPageIsLoading}
                            />
                        ))}
                    <ClaimItem
                        contract={contract}
                        onClaimed={() => loadAllTokens()}
                        setPageIsLoading={setPageIsLoading}
                    />

                    <VStack pt="5">
                        <Checkbox isChecked={aliveOnly} onChange={(e) => setAliveOnly(e.target.checked)}>
                            死んだNFTを表示しない
                        </Checkbox>
                        <Button
                            onClick={() => reload()}
                            leftIcon={<RepeatIcon />}
                            title="画像を強制的に再読み込み"
                            size="sm"
                        >
                            画像更新
                        </Button>
                    </VStack>
                </VStack>
            </ContractLayout>
        </BaseLayout>
    );
}
